import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-success\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 1024C229.229714 1024 0 794.770286 0 512S229.229714 0 512 0s512 229.229714 512 512-229.229714 512-512 512z m209.217829-686.606629L425.003886 636.489143l-167.936-163.591314-61.2352 62.8736L426.115657 760.100571l357.463772-360.945371-62.3616-61.761829z\" p-id=\"2059\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol